import React from 'react';

import { GoogleMap, TrafficLayer } from 'react-google-maps';

import { googleMapsEnhance } from 'modules/google-maps/utils';
import MarkerWithInfoWindow from 'modules/google-maps/MarkerWithInfoWindow';

import DriverNameLoader from 'modules/driver-position/DriverNameLoader';

const spainDefaults = {
  defaultZoom: 7,
  defaultCenter: { lat: 40.416775, lng: -3.70379 },
};

const londonDefaults = {
  defaultZoom: 8,
  defaultCenter: { lat: 51.5074, lng: 0.1278 },
};

const defaultsPerCountry = {
  ES: spainDefaults,
  UK: londonDefaults,
};

const DriverPositionMap = googleMapsEnhance(({ country, positions = [], children, ...props }) => (
  <GoogleMap {...(defaultsPerCountry[country] || defaultsPerCountry.ES)} {...props}>
    {positions.map(({ latitude, longitude, user_id }, key) => (
      <MarkerWithInfoWindow
        key={key}
        position={{ lat: latitude, lng: longitude }}
        content={<DriverNameLoader user_id={user_id} />}
      />
    ))}
    <TrafficLayer autoUpdate />
    {children}
  </GoogleMap>
));

export default DriverPositionMap;
